import { CSSProperties } from 'react';

const DOT_COUNT = 12;

const PulsingBubblesSpinner = (): JSX.Element => (
    <div className="pulsing-bubbles">
        {Array.from({ length: DOT_COUNT }, (_, i) => (
            <div
                key={i}
                className="pulsing-bubbles__dot"
                style={{
                    transform: `rotate(${(360 / DOT_COUNT) * i}deg)`,
                    '--pulsing-bubbles-delay': `${(1.2 / DOT_COUNT) * i}s`,
                } as CSSProperties}
            />
        ))}
    </div>
);

export default PulsingBubblesSpinner;
